import React from "react";

function HeaderMobileMenuButton({ toggleMobileMenu, showMobileMenu }) {
  return (
    <div
      className={`header-menu-link ${
        showMobileMenu ? "header-menu-link-open" : ""
      }`}
      onClick={toggleMobileMenu}
      role="button"
    >
      <span className="header-menu-link-hamburger">
        {showMobileMenu ? "x" : "☰"}
      </span>
    </div>
  );
}

export default HeaderMobileMenuButton;
